import { GTM_ERROR_CODES } from '../error-codes';

(() => {
    document.addEventListener('Checkout_Email_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error',
            error_id: GTM_ERROR_CODES.ERROR_FORM_CHECKOUT_EMAIL,
        });
    });

    document.addEventListener('Checkout_Login_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error',
            error_id: GTM_ERROR_CODES.ERROR_FORM_CHECKOUT_LOGIN,
        });
    });

    document.addEventListener('Checkout_GuestCustomerData_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error',
            error_id: GTM_ERROR_CODES.ERROR_FORM_CHECKOUT_GUEST_CUSTOMER_DATA,
        });
    });

    document.addEventListener('Checkout_AddressForm_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error',
            error_id: GTM_ERROR_CODES.ERROR_FORM_CHECKOUT_ADDRESS,
        });
    });
})();
